import {
  incomingSections,
  incomingDepartments,
  incomingEmpDepartments,
  incomingSectionExist,
} from '../../../types/Sections/SectionsTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../utils/apiUtils'
import { sectionsApiConfig, AllowedHttpMethods } from '../apiList'

const getDepartments = async (): Promise<incomingDepartments[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: sectionsApiConfig.getDepartments,
    method: AllowedHttpMethods.get,
  })
  const response = await useAxios(requestConfig)
  return response.data
}
const getEmpDepartments = async (): Promise<incomingEmpDepartments[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: sectionsApiConfig.getEmpDepartments,
    method: AllowedHttpMethods.get,
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const getSections = async (deptId: number): Promise<incomingSections[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: sectionsApiConfig.getSections,
    method: AllowedHttpMethods.get,
    params: {
      deptId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const isSectionExist = async (
  departmentId: number,
  sectionName: string,
): Promise<boolean> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: sectionsApiConfig.isSectionExist,
    method: AllowedHttpMethods.get,
    params: {
      departmentId,
      sectionName,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const saveSection = async (
  departmentId: number,
  sectionName: string,
): Promise<incomingSectionExist[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: sectionsApiConfig.saveSection,
    method: AllowedHttpMethods.post,
    data: {
      departmentId,
      sectionName,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const editSection = async (
  checklistsectionId: number,
  sectionName: string,
  departmentId: number,
): Promise<incomingSectionExist[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: sectionsApiConfig.editSection,
    method: AllowedHttpMethods.put,
    data: {
      checklistsectionId,
      sectionName,
      departmentId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const deleteSection = async (checklistsectionId: number): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: sectionsApiConfig.deleteSection,
    method: AllowedHttpMethods.delete,
    params: {
      checklistsectionId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const SectionsApi = {
  getDepartments,
  getEmpDepartments,
  getSections,
  isSectionExist,
  saveSection,
  editSection,
  deleteSection,
}

export default SectionsApi
